import { ProviderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

interface UseParams {
  providerId: string;
  locationId: string;
  xTENANTID?: string;
}

/**
 * @author Shrinivas Mandhare
 */
export const useAssignProviderToLocation = () =>
  useMutationWithLoading(async (params: UseParams) =>
    new ProviderControllerApi(getConfigObject()).assignDProviderToLocation(
      params.providerId,
      params.locationId,
      params.xTENANTID
    )
  );
